
export default {
  name: "PartnersPage",
};
